export default "__VITE_ASSET__Dr2PTqvK__"